<template>
  <div :class="['device-record-page', {'block-pop': popped}]">
    <!-- <img class="titl" src="/static/images/device/gzbyqd.png"> -->
    <div class="table-data">
      <div class="tab-switch">
        <span :class="[{'current': item==tabKey}]" v-for="item in tabData" v-text="item"
          @click="tabSwitch(item)"></span>
      </div>
      <table v-if="tabKey=='故障清单'">
        <thead>
          <tr>
            <th width="120">时间</th>
            <th :width="popped?150:140">仓库名称</th>
            <th>设备类型</th>
            <th>故障原因</th>
            <th>处理方法</th>
            <th>处理人员</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in faultList[0].retData.Rows">
            <td>
              <span v-text="$formatDateTime(new Date(item.BreakDownTime).getTime()/1000, 'yy/MM/dd')"></span>
            </td>
            <td>
              <span v-text="item.WareHouseName"></span>
            </td>
            <td>
              <span v-text="item.EquipmentType"></span>
            </td>
            <td>
              <span class="tdtxt" v-text="item.BreakDowmReason"></span>
              <div class="full-box" v-if="item.BreakDowmReason">
                <span class="txt" v-text="item.BreakDowmReason"></span>
              </div>
            </td>
            <td>
              <span class="tdtxt" v-text="item.HandleMethod"></span>
              <div class="full-box" v-if="item.HandleMethod">
                <span class="txt" v-text="item.HandleMethod"></span>
              </div>
            </td>
            <td>
              <span v-for="(person, index) in JSON.parse(item.Handler)"
                v-text="person.Name+(index<JSON.parse(item.Handler).length-1?',':'')"></span>
            </td>
          </tr>
        </tbody>
      </table>
      <table v-if="tabKey=='保养清单'">
        <thead>
          <tr>
            <th width="120">时间</th>
            <th :width="popped?150:140">仓库名称</th>
            <th>设备类型</th>
            <th>保养原因</th>
            <th>保养类型</th>
            <th>处理人员</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in upkeepList[0].retData.Rows" v-if="upkeepList.length>0">
            <td>
              <span v-text="$formatDateTime(new Date(item.CreateTime).getTime()/1000, 'yy/MM/dd')"></span>
            </td>
            <td>
              <span v-text="item.WareHouseName"></span>
            </td>
            <td>
              <span v-text="item.EquipmentType"></span>
            </td>
            <td>
              <span class="tdtxt" v-text="item.MaintenanceReason"></span>
              <div class="full-box" v-if="item.MaintenanceReason">
                <span class="txt" v-text="item.MaintenanceReason"></span>
              </div>
            </td>
            <td>
              <span class="tdtxt" v-text="item.MaintenanceType"></span>
              <div class="full-box" v-if="item.MaintenanceType">
                <span class="txt" v-text="item.MaintenanceType"></span>
              </div>
            </td>
            <td>
              <span class="tdtxt" v-for="(person, index) in JSON.parse(item.Handler)"
                v-text="person.Name+(index<JSON.parse(item.Handler).length-1?',':'')"></span>
              <div class="full-box" v-if="item.Handler">
                <span class="txt" v-for="(person, index) in JSON.parse(item.Handler)"
                v-text="person.Name+(index<JSON.parse(item.Handler).length-1?',':'')"></span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="page-container">
        <v-pagination :total="totalCount" :display="pageSize" :current-page="pageIndex" @pagechange="pageChange">
        </v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import pagination from "@/components/widgets/Pagination";
  export default {
    components: {
      "v-pagination": pagination
    },
    data() {
      let tabData = ["故障清单", "保养清单"];
      return {
        itemList: [], //清单
        // 故障清单
        faultList: [
          {
            "retStatus": 1,
            "isSuccess": true,
            "retMsg": "",
            "Count": 0,
            retData: {
              "TotalCount": 24,
              "TotalPageCount": 0,
              "Rows": [
                {
                  "WareHouseName": "片烟库",
                  "EquipmentType": "堆垛机",
                  "EquipmentCode": "2PY_SR5#",
                  "BreakDownMessage": "堆垛机放货时报高低位检测光电被触发",
                  "BreakDownType": "较大故障",
                  "BreakDowmReason": "现场查看怀疑是因为该货架之前被撞歪，导致不水平，放货时光电被触发",
                  "HandleMethod": "手动将货叉收回，并查看货架状态，确认要等停产后再进行维修，暂时先禁用A005027004001、A005026004001、A005025004001这三个货位，改为可出不可入。",
                  "BreakDownDescription": "故障维修",
                  "BreakDownTime": "2019-07-04T14:33:00",
                  "HandleTime": 27,
                  "EffectTime": "27",
                  "Handler": "[{\"_id\":\"9\",\"Name\":\"杨文杰,林华星,许建国\",\"UserName\":\"杨文杰,林华星,许建国\"}]",
                  "Count": 1, "CreateTime": "2019-07-04T14:33:00"
                },
                {
                  "WareHouseName": "片烟库",
                  "EquipmentType": "WCS",
                  "EquipmentCode": "2PY_WCS",
                  "BreakDownMessage": "网络连不上片烟库堆垛机scs",
                  "BreakDownType": "较大故障",
                  "BreakDowmReason": "网络接线问题",
                  "HandleMethod": "进行线路排查，待早班处理",
                  "BreakDownDescription": "其他维修",
                  "BreakDownTime": "2019-06-25T20:00:00",
                  "HandleTime": 30,
                  "EffectTime": "30",
                  "Handler": "[{\"_id\":\"11\",\"Name\":\"严之一,罗俊,陈云鹏\",\"UserName\":\"严之一,罗俊,陈云鹏\"}]",
                  "Count": 1,
                  "CreateTime": "2019-06-25T20:00:00"
                },
                {
                  "WareHouseName": "片烟库",
                  "EquipmentType": "WCS",
                  "EquipmentCode": "2PY_WCS",
                  "BreakDownMessage": "scs连接异常",
                  "BreakDownType": "一般故障",
                  "BreakDowmReason": "网线松动",
                  "HandleMethod": "重新紧固",
                  "BreakDownDescription": "故障维修",
                  "BreakDownTime": "2019-08-31T09:00:00",
                  "HandleTime": 5,
                  "EffectTime": "10",
                  "Handler": "[{\"_id\":\"1\",\"Name\":\"姚文琛,康金华\",\"UserName\":\"姚文琛,康金华\"}]",
                  "Count": 1,
                  "CreateTime": "2019-08-31T09:00:00"
                },
                {
                  "WareHouseName": "片烟库",
                  "EquipmentType": "堆垛机",
                  "EquipmentCode": "2PY_SR5#",
                  "BreakDownMessage": "有一个目的地为A006011001001的12日的空托盘组入库任务执行中",
                  "BreakDownType": "一般故障",
                  "BreakDowmReason": "查看WCS状态为执行中，查看WMS货位状态为待入库",
                  "HandleMethod": "进入巷道查看货位情况，发现货位为空。回收WMS的任务",
                  "BreakDownDescription": "故障维修",
                  "BreakDownTime": "2019-06-13T10:30:00",
                  "HandleTime": 15,
                  "EffectTime": "15",
                  "Handler": "[{\"_id\":\"13\",\"Name\":\"许博\",\"UserName\":\"许博\"}]",
                  "Count": 1,
                  "CreateTime": "2019-06-13T10:30:00"
                },
                {
                  "WareHouseName": "片烟库",
                  "EquipmentType": "WCS",
                  "EquipmentCode": "2PY_WCS",
                  "BreakDownMessage": "死机",
                  "BreakDownType": "一般故障",
                  "BreakDowmReason": "WCS无故弹出故障窗口",
                  "HandleMethod": "重启WCS",
                  "BreakDownDescription": "故障维修",
                  "BreakDownTime": "2019-06-08T14:35:00",
                  "HandleTime": 5,
                  "EffectTime": "5",
                  "Handler": "[{\"_id\":\"15\",\"Name\":\"许博\",\"UserName\":\"许博\"}]",
                  "Count": 1, "CreateTime": "2019-06-08T14:35:00"
                }
              ]
            }
          }
        ],
        // 保养清单
        upkeepList: [
          {
            "retStatus": 1,
            "isSuccess": true,
            "retMsg": "",
            "Count": 0,
            "retData": { 
             "TotalCount": 4859,
             "TotalPageCount": 0,
             "Rows": [
                {
                    "WareHouseName": "片烟库",
                    "EquipmentType": "GK",
                    "EquipmentCode": "2PY_Intouch02",
                    "MaintenanceReason": "合格",
                    "MaintenanceType": "任务状态是否正常",
                    "MaintenanceDescription":
                    "观察任务是否正常",
                    "MaintenanceTime": "2019-08-01T09:25:45", 
                    "HandleTime": null,
                    "Handler": "[{\"_id\":\"1\",\"Name\":\"罗俊,郑晗,文榆清,许博,康金华,李益龙,李苏惠,连旭\",\"UserName\":\"罗俊,郑晗,文榆清,许博,康金华,李益龙,李苏惠,连旭\"}]",
                    "Count": 1, 
                    "CreateTime": "2019-08-01T09:25:45" }
                   , 
                {
                    "WareHouseName": "片烟库",
                    "EquipmentType": "GK",
                    "EquipmentCode": "2PY_Intouch02",
                    "MaintenanceReason": "合格",
                    "MaintenanceType": "任务状态是否正常",
                    "MaintenanceDescription": "观察任务是否正常",
                    "MaintenanceTime": "2019-08-02T10:40:02",
                    "HandleTime": null,
                    "Handler": "[{\"_id\":\"2\",\"Name\":\"罗俊,郑晗,文榆清,许博,康金华,李益龙,李苏惠,连旭\",\"UserName\":\"罗俊,郑晗,文榆清,许博,康金华,李益龙,李苏惠,连旭\"}]",
                    "Count": 1,
                    "CreateTime": "2019-08-02T10:40:02" },
                    { 
                    "WareHouseName": "片烟库",
                    "EquipmentType": "GK", 
                    "EquipmentCode": "2PY_Intouch02",
                    "MaintenanceReason": "合格",
                    "MaintenanceType": "任务状态是否正常",
                    "MaintenanceDescription": "观察任务是否正常",
                    "MaintenanceTime": "2019-08-07T09:09:27",
                    "HandleTime": null,
                    "Handler": "[{\"_id\":\"3\",\"Name\":\"罗俊,郑晗,文榆清,许博,康金华,李益龙,李苏惠,连旭\",\"UserName\":\"罗俊,郑晗,文榆清,许博,康金华,李益龙,李苏惠,连旭\"}]", "Count": 1, "CreateTime": "2019-08-07T09:09:27" 
                  }, 
                  { 
                    "WareHouseName": "片烟库", 
                    "EquipmentType": "GK", 
                    "EquipmentCode": "2PY_Intouch02", 
                    "MaintenanceReason": "合格", 
                    "MaintenanceType": "任务状态是否正常", 
                    "MaintenanceDescription": "观察任务是否正常", 
                    "MaintenanceTime": "2019-08-06T08:48:11", 
                    "HandleTime": null, 
                    "Handler": "[{\"_id\":\"4\",\"Name\":\"林华星\",\"UserName\":\"林华星\"}]", 
                    "Count": 1, "CreateTime": "2019-08-06T08:48:11" },
                  { 
                    "WareHouseName": "片烟库", 
                    "EquipmentType": "GK", 
                    "EquipmentCode": "2PY_Intouch02", 
                    "MaintenanceReason": "合格", 
                    "MaintenanceType": "任务状态是否正常", 
                    "MaintenanceDescription": "观察任务是否正常", 
                    "MaintenanceTime": "2019-08-05T08:48:30", 
                    "HandleTime": null, 
                    "Handler": "[{\"_id\":\"5\",\"Name\":\"严之一\",\"UserName\":\"严之一\"}]", "Count": 1, "CreateTime": "2019-08-05T08:48:30" 
                  }]}
          }
        ],
        tabData: tabData,
        tabKey: tabData[0],
        popped: false,
        totalCount: 0, //总数据
        pageIndex: 1,
        pageSize: 5,
      };
    },
    props: ["StartDates", "EndDates"],
    watch: {
      popped(val) {
        if (!val) {
          this.pageSize = 5;
        } else {
          this.pageSize = 5 * 2 + 1;
        }
        this.pageChange(1);
      },
    },
    mounted() {
      //定义全局方法
      // window.gbfc_resetData = this.resetData;
      window.gbfc_popupWindow = this.popupWindow;
      //初始化
      this.$initPage(this);
    },
    methods: {
      resetData() {
        //
        this.getItemList1();
      },
      popupWindow(val) {
        this.popped = val;
      },
      tabSwitch(item) {
        this.tabKey = item;
        this.getItemList1();
      },
      getItemList1() {
        let self = this;
        let url = "";
        this.itemList = [];

        if (this.tabKey == "故障清单") {
          url = window.ApiHost1 + "/api/DataStatistical/Equip_BreakDown_Info";
        } else {
          url = window.ApiHost1 + "/api/DataStatistical/Equip_Maintenance_Info";
        }
        this.$handleRequest(
          url,
          {
            PageIndex: this.pageIndex,
            PageSize: this.pageSize,
            EquipmentCode: "",
            StartDate: this.StartDates,
            EndDate: this.EndDates,
            WareHouseCode: window.PYKWareHouseCode
          },
          "post",
          function (res) {
            console.log(res)
            //success
            self.itemList = res.retData.Rows;
            self.totalCount = res.retData.TotalCount;
          },
          function (res) {
            //fail
          }
        );
      },
      pageChange(pageIndex) {

        this.pageIndex = pageIndex;
        this.getItemList1();
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/xiayan/device/DeviceMaintainRecord.vue